import { Tag } from 'antd';
import styled from 'styled-components';
interface ICustomTag {
  $textColor?: string;
  $bgColor?: string;
  $borderColor?: string;
}
export const CustomTag = styled(Tag).withConfig({
  displayName: "Tagstyle__CustomTag",
  componentId: "sc-1ig9ig1-0"
})(["", " color:", ";background-color:", ";border:", ";@media (max-width:", "){", "}"], {
  "margin": "0px",
  "width": "fit-content",
  "borderRadius": "1rem",
  "paddingLeft": "0.75rem",
  "paddingRight": "0.75rem",
  "paddingTop": "0.25rem",
  "paddingBottom": "0.25rem",
  "fontSize": "1rem",
  "lineHeight": "18px",
  "fontWeight": "400"
}, ({
  $textColor,
  theme
}) => $textColor ?? theme.colors.grey[40], ({
  $bgColor
}) => `${$bgColor ?? '#ffffff'}`, ({
  $borderColor,
  theme
}) => `1px solid ${$borderColor ?? theme.colors.grey[10]}`, ({
  theme
}) => theme.breakpoint.md, {
  "fontSize": "0.75rem",
  "lineHeight": "14px"
});
export const CustomTagWithIcon = styled(Tag).withConfig({
  displayName: "Tagstyle__CustomTagWithIcon",
  componentId: "sc-1ig9ig1-1"
})(["", " color:", " !important;.icon{", "}@media (max-width:", "){", " .icon{", "}}"], {
  "margin": "0px",
  "borderRadius": "1.5rem",
  "paddingLeft": "0.75rem",
  "paddingRight": "0.75rem",
  "paddingTop": "0.5rem",
  "paddingBottom": "0.5rem",
  "fontSize": "28px",
  "fontWeight": "500",
  "lineHeight": "1"
}, ({
  theme,
  $textColor
}) => $textColor ?? theme.colors.orange[50], {
  "aspectRatio": "1 / 1",
  "width": "2rem"
}, ({
  theme
}) => theme.breakpoint.md, {
  "padding": "0.5rem",
  "fontSize": "1.5rem",
  "lineHeight": "2rem"
}, {
  "width": "1.5rem"
});
export const Detail = styled.div.withConfig({
  displayName: "Tagstyle__Detail",
  componentId: "sc-1ig9ig1-2"
})(["", ""], {
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "center",
  "gap": "0.5rem"
});